module.exports = __webpack_public_path__ + "images/1e2012026c34f6146a390d0a1edfc9f57.svg";